import { render, staticRenderFns } from "./LocationDelivery.vue?vue&type=template&id=5882211d"
import script from "./LocationDelivery.vue?vue&type=script&lang=ts"
export * from "./LocationDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports